import type { IExtractRouteParamMap, IRouteTranslation } from "../../../types";
import {
  concatBreadcrumbs,
  createBreadcrumbObject,
  createPaths,
} from "../../../utils";

import {
  courseChapterBreadcrumbs,
  courseChaptersRoutesObj,
} from "@routes/facultyMember/courseManagement/courseChapter/path";

// Base route constant
const baseRoute = `${courseChaptersRoutesObj.view}/slide` as const;

// * Route configuration object for courseChapterSlides-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const courseChapterSlidesRoutesObj = {
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:slideId`,
  edit: `${baseRoute}/edit/:slideId`,
} as const;

// ! these are breadcrumbs translation not page title
const courseChapterSlidesRouteTranslation: IRouteTranslation<
  typeof courseChapterSlidesRoutesObj
> = {
  create: "addSlide",
  edit: "editSlide",
  view: "viewSlide",
};

// * Extracts the route parameters for the course-chapter-Slides route configuration.
export type ICourseChapterSlidesRouteParams = IExtractRouteParamMap<
  typeof courseChapterSlidesRoutesObj
>;

// * Path functions for the course-chapter-Slides routes.
export const courseChapterSlidesPath = createPaths<
  typeof courseChapterSlidesRoutesObj,
  ICourseChapterSlidesRouteParams
>(courseChapterSlidesRoutesObj);

// * Breadcrumbs {translation and route} for the course chapter Slides routes
const thisCourseChapterSlidesBreadcrumbs = createBreadcrumbObject<
  typeof courseChapterSlidesRoutesObj
>(courseChapterSlidesRoutesObj, courseChapterSlidesRouteTranslation);

export const courseChapterSlidesBreadcrumbs = concatBreadcrumbs<
  typeof courseChapterSlidesRoutesObj
>(courseChapterBreadcrumbs.view, thisCourseChapterSlidesBreadcrumbs);
